import { ReactNode, useContext } from "react";
import styled from "styled-components";
import ProjectContext from "../../store/project-context";
import { ProjectKeyType } from "../../interface/project";
import { media } from "../../lib/styles/media";

const Component = styled.div`
  box-sizing: border-box;
  white-space: nowrap;
  cursor: inherit;
`;

const RadioInput = styled.input`
  display: none;

  &:checked + label {
    background: rgba(255, 255, 255, 0.9);
    color: #000;
    font-family: "S-CoreDream-7EXTRA_BOLD";
    border-color: rgba(255, 255, 255, 0.6);
  }
`;

const InputLabel = styled.label`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 5px;
  padding: 10px 15px;
  background: rgba(255, 255, 255, 0.12);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  color: #fff;
  border-radius: 20px;
  user-select: none;
  font-family: "S-CoreDream-3Light";
  font-weight: 600;
  cursor: inherit;
  transition: all 0.2s;

  &:hover {
    background: rgba(255, 255, 255, 0.22);
  }

  ${media.phone`
    font-size: 14px;
  `}
`;

interface ComponentType {
  id: ProjectKeyType;
  children: ReactNode;
  checked?: boolean;
  name: string;
}

export default function ProjectButton(props: ComponentType) {
  const { id, children, checked, name } = props;
  const context = useContext(ProjectContext);
  const { setProject } = context;

  const handleClickButton = () => {
    setProject(id);
  };
  return (
    <Component>
      {/* 프로젝트 버튼 */}
      <RadioInput id={id} name={name} defaultChecked={checked} type="radio" />
      <InputLabel onClick={() => handleClickButton()} htmlFor={id}>
        {children}
      </InputLabel>
    </Component>
  );
}
